<template>
  <div class="mega-menu"
       :class="classes">
    <div class="mega-menu__container">
      <div class="mega-menu__content">
        <slot>Content!</slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MegaMenu",
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      const result = [];

      if ( this.open ) {
        result.push( "mega-menu--open" );
      }

      return result;
    }
  }
};
</script>

<style lang="less" scoped>
@transition-timing: 0.2s;
@transition-function: cubic-bezier(0.56, 0.34, 0.76, 0.66);
@column-width: 230px;

.mega-menu {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: #fff;
  opacity: 0.5;
  z-index: -1;
  overflow: hidden;
  transition: all @transition-timing @transition-function;
  transform: translateY( -100% );
  background: darken( #008385, 6% );

  &--shop {
    background: #008385;
  }

  &--services {
    background: #0c499c;
  }

  &__container {
    padding: 30px;
    padding-top: 90px;
    overflow: hidden;
  }

  &__content {
    opacity: 0;
    transition: all @transition-timing @transition-function;
    padding-left: 135px;
  }

  &__columns {
    display: flex;
    align-items: stretch;
  }

  &__column {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-right: 30px;
    width: @column-width;
    flex-grow: 0;
    margin-bottom: 15px;
  }

  &__column-heading {
    color: #fff;
    font-size: 1.25rem;
    margin-bottom: 15px;

    &--link {
      &:hover {
        text-decoration: underline;
      }
    }
  }

  &__column-list {
    flex-grow: 1;
    padding: 0;
    margin: 0;
    list-style-type: none;
  }

  &__column-item {
    color: #fff !important;
    font-size: 13px;
  }

  &__link {
    font-weight: 400 !important;
    color: #fff !important;
    display: flex;
    justify-content: flex-start;

    &:hover {
      text-decoration: underline !important;
    }
  }

  &__link-icon {
    padding-right: 5px;
    font-size: 0.6rem;
    padding-top: 5px;
  }

  &__quick-links {
    margin: 0 -15px;
    padding: 0;
    list-style: none;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  &__quick-links-item {
    display: flex;
    padding: 0 15px;
    align-items: center;
    color: #fff !important;
    width: @column-width;
  }

  &__quick-link {
    padding: 15px 10px;
    font-weight: 700;
    font-size: 1.1rem !important;
    color: #fff !important;
    display: block;
    transition: color 0.1s linear;

    &:hover {
      color: #ddd !important;
    }
  }

  &--open {
    top: 0; // prevents issue with transform stacking context overlapping content until opened
    bottom: auto;
    opacity: 1;
    transform: translate3d(0, 0, 0);
    box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.3), 0 0 15px 0 rgba(0, 0, 0, 0.2);

    .mega-menu__content {
      opacity: 1;
    }
  }

  @media (max-width: 991px) {
    position: static;
    display: none;
  }
}
</style>
